// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2p2YA","file":"styles_file__1nCP0"};